import React from 'react';
import {Icon, svgs, Message, Link} from 'epic-diesel-common';

//@ts-ignore
import styles from './PageNav.pcss';

interface Props {
    to: string;
    returnText?: string | React.ReactNode;
    title?: string;
}

const CODES = {
    returnText: 'epic.affiliate.common.back'
};

const PageNav: React.FC<Props> = props => {
    let returnText;

    if (typeof props.returnText === 'string') {
        returnText = <span>{props.returnText}</span>; // plaintext
    } else {
        returnText = props.returnText || <Message code={CODES.returnText} />;
    }

    return (
        <div className={styles.pageNav}>
            <ul>
                <li>
                    <Link to={props.to}>
                        <Icon className={styles.icon} icon={svgs.CHEVRON_THIN} fontSize="small" />
                        {returnText}
                    </Link>
                </li>
                {props.title && (
                    <li>
                        <span>{props.title}</span>
                    </li>
                )}
            </ul>
        </div>
    );
};

export default PageNav;
